<template>
  <v-container grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex xs12 md12>
        <invoice-screen
          :firms="firms"
          :banks="banks"
          :buyers="buyers"
          :sellers="sellers"
          @updateInvoiceReturnData="updateInvoiceReturnData"
          @updateInvoiceData="updateInvoiceData"
          :buyerId="buyerId"
          :invoiceData="invoiceData"
          :returnInvoiceData="returnInvoiceData"
          @close="close"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import InvoiceScreen from "./InvoiceScreen";
export default {
  name: "InvoiceReturn",
  components: {
    InvoiceScreen,
  },
  props: {
    buyerId: {
      required: true,
    },
    isBuyer: {
      required: true,
    },
    invoiceDetail: {
      required: true,
      type: Object,
    },
    firms: {
      type: Array,
    },
    banks: {
      type: Array,
    },
    buyers: {
      type: Array,
    },
    sellers: {
      type: Array,
    },
  },
  data() {
    return {
      formIsValid: true,
      form: [{}],
      invoiceData: this.invoiceDetail,
      returnInvoiceData: JSON.parse(JSON.stringify(this.invoiceDetail)),
      orignalInvoiceData: JSON.parse(JSON.stringify(this.invoiceDetail)),
    };
  },
  created() {
    // this.reset()
  },
  watch: {
    buyerId(val) {
      this.reset();
    },
  },
  methods: {
    reset() {
      this.invoiceData = {
        items: [],
        buyerId: this.buyerId,
      };
    },
    close() {
      console.log("this.isBuyer", this.isBuyer);
      this.invoiceData["return"] = true;
      if (this.isBuyer) {
        this.invoiceData["isCredited"] = false;
        this.invoiceData["isBuyer"] = true;
      } else {
        this.invoiceData["isCredited"] = true;
        this.invoiceData["isBuyer"] = false;
      }
      // this.$emit('returnInvoice', Object.assign({}, this.invoiceData),Object.assign({}, this.returnInvoiceData))
      this.$emit(
        "returnInvoice",
        Object.assign({}, this.orignalInvoiceData),
        Object.assign({}, this.invoiceData),
        Object.assign({}, this.returnInvoiceData)
      );
      this.reset();
    },
    updateInvoiceData(data) {
      this.invoiceData = data;
    },
    updateInvoiceReturnData(data) {
      this.returnInvoiceData = data;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Buyers/InvoiceReturn/index.vue